<template>
    <div class="card-panel hoverable">
        <h4 class="card-title">Outstanding Issues</h4>
        <div class="divider"></div>
        <div class="row">
            <div class="col s12 m12 l12">

                <div v-if="loadByUserId === 0 && isAdmin">Select a member to display.</div>
                <div v-else>
                    <span v-if="loading">Loading ...</span>
                    <div v-if="!hasData && !loading && !isAdmin">
                        <h6>There is no ongoing issue data.</h6>
                        <a :href="createIssueUrl"
                           class="btn waves-light" style="margin-top: 15px">Create a Issue</a>
                    </div>

                    <div v-if="!hasData && !loading && isAdmin">
                        <h6>There is no ongoing issues data for this member.</h6>
                    </div>

                    <table class="responsive-table" v-show="!loading && hasData">
                        <thead>
                        <tr>
                            <th>Name</th>
                            <th>Category</th>
                            <th>Action</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-for="issue in data">
                            <td>{{ issue.name }}</td>
                            <td>{{ issue.issue_category.title }}</td>
                            <td>
                                <a :href="pdfUrl + '/' + issue.id" target="_blank"><i class="material-icons">file_download</i></a>
                            </td>
                        </tr>
                        </tbody>
                    </table>
                </div>

            </div>
        </div> <!-- ./card content -->
    </div>
</template>

<script>
  import axios from 'axios';

  export default {
    name: 'OutstandingIssueComponent',

    props: [
      'dataUrl',
      'pdfUrl',
      'createIssueUrl',
      'haltInitiate',
      'isAdmin',
      'selectedUser'
    ],

    data () {
      return {
        hasData: false,
        loading: true,
        data: [],
        loadByUserId: 0
      }
    },

    watch: {
      selectedUser () {
        // from dashboard component
        this.loadByUserId = this.selectedUser.id;
        this.load();
      }
    },

    mounted () {

      // window.addEventListener('reload_outstanding_issue_summary', (payload) => {
      //   this.loadByUserId = payload.detail.user_id;
      //   this.load();
      // });

      if (this.haltInitiate) {
        return;
      }

      this.load();
    },

    methods: {
      deselectUserId () {
        this.loadByUserId = 0;
        this.hasData = false;
      },

      load () {
        this.loading = true;
        this.data = [];
        let data = '?user_id=' + this.loadByUserId;

        axios.post(this.dataUrl + data)
          .then((res) => {
            this.loading = false;

            this.hasData = (res.data.data.length > 0);

            res.data.data.forEach((item) => {
              this.data.push(item);
            });
          });
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// resources/assets/js/components/issues/partials/OutstandingIssueComponent.vue